import { HttpTypes } from '@medusajs/types'
import { getProductPrice } from '../utils/get-product-price'

export type UseProductPriceResult = {
  hasPriceData: boolean
  displayPrice: number | null
  currency: string
  hasDiscount: boolean
  originalPrice: number | null
  discountPercent: number
}

export function useProductPrice({
  product,
  variant,
}: {
  product: HttpTypes.StoreProduct
  variant?: HttpTypes.StoreProductVariant
}): UseProductPriceResult {
  const { cheapestPrice, variantPrice } = getProductPrice({
    product,
    variantId: variant?.id,
  })

  const selectedPrice = variant ? variantPrice : cheapestPrice

  const price = variant?.calculated_price?.calculated_amount
  const originalPrice = variant?.calculated_price?.original_amount
  const currency = variant?.calculated_price?.currency_code?.toUpperCase() || 'EUR'

  const hasDiscount = price != null && originalPrice != null && originalPrice > price
  const discountPercent = hasDiscount
    ? Math.round(((originalPrice - price) / originalPrice) * 100)
    : 0

  const displayPrice = price ?? selectedPrice?.calculated_price_number ?? null

  return {
    hasPriceData: !!selectedPrice,
    displayPrice,
    currency,
    hasDiscount,
    originalPrice: hasDiscount ? (originalPrice as number) : null,
    discountPercent,
  }
}
